import { DEFAULT_API_CONFIG } from './apiConfig';

const { url, getHeaders } = DEFAULT_API_CONFIG;
const baseRoute = `${url}/RCT`;

export const testRCTFileRequest = async rctTestFile => {
  const url = `${baseRoute}/testRCTFileRequest/${rctTestFile}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const GetRCTFileRequest = async () => {
  const url = `${baseRoute}/GetInspections`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const GetCIGFileRequest = async () => {
  const url = `${baseRoute}/GetCIGInspections`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const PostRCTAnswers = async (rctAnswers, orderLineId) => {
  const url = `${baseRoute}/SaveRCTAnswers/${orderLineId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(rctAnswers),
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const PostRCTOrder = async (orderLineId, clientId) => {
  const url = `${baseRoute}/PostToRCTApi/${orderLineId}/${clientId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const UpdateMasterRecs = async () => {
  const url = `${baseRoute}/GetUpdateMasterRecs`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};
